import { Injectable } from '@angular/core';

import * as $ from 'jquery';

@Injectable({
  providedIn: 'root'
})
export class SpinnerServiceService {

  constructor() { }

 public static showSpinner() {
    $(".spinner-container").fadeIn();
    $("body").css("overflow-y", "hidden");
  }

 public static hideSpinner() {
    $(".spinner-container").fadeOut();
    $("body").css("overflow-y", "auto");
  }
}
